export type CommentActorRole = "ADMIN" | "USER" | "VIEWER"

export const COMMENT_DELETE_FORBIDDEN =
	"Only admins can delete comments written by someone else"

export function canDeleteComment({
	commentUserId,
	actorUserId,
	role,
}: {
	commentUserId: string | null | undefined
	actorUserId: string | null | undefined
	role: CommentActorRole | null | undefined
}): boolean {
	if (role === "ADMIN") return true
	if (role === "VIEWER") return false
	return Boolean(actorUserId) && commentUserId === actorUserId
}

export function canEditComment({
	commentUserId,
	actorUserId,
}: {
	commentUserId: string | null | undefined
	actorUserId: string | null | undefined
}): boolean {
	return Boolean(actorUserId) && commentUserId === actorUserId
}
